import { Col, Row } from '@/app/components/Flex/Flex'
import { Text } from '@/app/components/Text/Text'
import { UI } from '@/app/components/UI/UI'
import ArrowRightSvg from '@/app/icons/arrow-right.svg?react'
import classNames from 'classnames'
import type { FunctionalComponent } from 'preact'
import matrixPng from '../img/matrix.png'
import natalPng from '../img/natal.png'
import sanastryPng from '../img/sanastry.jpg'
import styles from './index.module.scss'

export const HeroDesktop: FunctionalComponent = () => {
  return (
    <div class={styles.desktop}>
      <section class={styles.hero}>
        <UI.Wrapper>
          <Row
            gap={40}
            gapMobile={20}
          >
            <div class={styles.header}>
              <Text
                fontSize={20}
                fontSizeMobile={16}
                fontWeight={700}
              >
                ZoeAstro
              </Text>

              <div class={styles.login}>
                <UI.Button
                  size='s'
                  type='whiteSecondary'
                  link='~/login'
                >
                  Вход
                </UI.Button>
              </div>
            </div>

            <UI.Holder>
              <Row
                gap={40}
                gapMobile={20}
              >
                <Text
                  as='h1'
                  fontSize={34}
                  fontSizeMobile={24}
                  fontWeight={500}
                  lineHeight={1}
                  textAlign='center'
                >
                  Открой свои<br />сильные стороны<br />и скрытый потенциал
                </Text>

                <Row
                  gap={20}
                  gapMobile={15}
                >
                  <UI.Panel
                    hover
                    radius='l'
                    type='glass'
                    link='~/tools?redirect=~/tools/natal'
                  >
                    <Col gap={15} alignItems='center'>
                      <img class={styles.pic} src={natalPng} alt='Пример натальной карты' />

                      <Row gap={5}>
                        <Col
                          gap={4}
                          alignItems='center'
                          justifyContent='space-between'
                        >
                          <Text
                            as='h2'
                            fontSize={20}
                            fontSizeMobile={18}
                            fontWeight={600}
                            lineHeight={1}
                          >
                            Натальная карта
                          </Text>

                          <ArrowRightSvg
                            opacity={0.3}
                            width={16}
                            height={16}
                            strokeWidth={2}
                            class='mobile'
                          />
                        </Col>

                        <Text
                          as='p'
                          fontSize={16}
                          fontSizeMobile={14}
                          lineHeight={1.25}
                          opacity={0.7}
                        >
                          <span class='desktop'>
                            Исследуй свои сильные стороны, особенности характера и с кем тебе будет хорошо.
                          </span>
                          <span class='mobile'>
                            Исследуй характер, сильные стороны и отношения.
                          </span>
                        </Text>
                      </Row>
                    </Col>
                  </UI.Panel>

                  <UI.Panel
                    hover
                    radius='l'
                    type='glass'
                    link='~/tools?redirect=~/tools/matrix'
                  >
                    <Col gap={15} alignItems='center'>
                      <img class={styles.pic} src={matrixPng} alt='Пример матрицы судьбы' />

                      <Row
                        gap={5}
                      >
                        <Col
                          gap={4}
                          alignItems='center'
                          justifyContent='space-between'
                        >
                          <Text
                            as='h2'
                            fontSize={20}
                            fontSizeMobile={18}
                            fontWeight={600}
                            lineHeight={1}
                          >
                            Матрица судьбы
                          </Text>

                          <ArrowRightSvg
                            opacity={0.3}
                            width={16}
                            height={16}
                            strokeWidth={2}
                            class='mobile'
                          />
                        </Col>

                        <Text
                          as='p'
                          fontSize={16}
                          fontSizeMobile={14}
                          lineHeight={1.25}
                          opacity={0.7}
                        >
                          <span class='desktop'>
                            Узнай, как добиться успеха и раскрыть свой потенциал на максимум.
                          </span>
                          <span class='mobile'>
                            Узнай, как добиться успеха и раскрыть свой потенциал.
                          </span>
                        </Text>
                      </Row>
                    </Col>
                  </UI.Panel>

                  <UI.Panel
                    hover
                    radius='l'
                    type='glass'
                    link='~/tools?redirect=~/tools/synastry'
                  >
                    <Col gap={15} alignItems='center'>
                      <img
                        alt='Иллюстрация влюбленной пары'
                        class={classNames(styles.pic, styles.synastry)}
                        src={sanastryPng}
                      />

                      <Row gap={5}>
                        <Col
                          gap={4}
                          alignItems='center'
                          justifyContent='space-between'
                        >
                          <Text
                            as='h2'
                            fontSize={20}
                            fontSizeMobile={18}
                            fontWeight={600}
                            lineHeight={1}
                          >
                            Совместимость
                          </Text>

                          <ArrowRightSvg
                            opacity={0.3}
                            width={16}
                            height={16}
                            strokeWidth={2}
                            class='mobile'
                          />
                        </Col>

                        <Text
                          as='p'
                          fontSize={16}
                          fontSizeMobile={14}
                          lineHeight={1.25}
                          opacity={0.7}
                        >
                          <span class='desktop'>
                            Проверь, что чувствует партнёр и насколько вы подходите друг другу.
                          </span>
                          <span class='mobile'>
                            Проверь, что чувствует партнёр и насколько вы подходите.
                          </span>
                        </Text>
                      </Row>
                    </Col>
                  </UI.Panel>

                  <Row gap={15} alignItems='center'>
                    <UI.Button
                      block
                      size='l'
                      type='white'
                      htmlType='button'
                      link='~/tools'
                    >
                      Начать разбор
                    </UI.Button>

                    <UI.Hint>
                      Бесплатный старт · Без карты · 1 минута
                    </UI.Hint>
                  </Row>
                </Row>
              </Row>
            </UI.Holder>
          </Row>
        </UI.Wrapper>
      </section>
    </div>
  )
}
